import React, { Component, Fragment } from 'react';
import { Alert, Button, Modal, ModalHeader, ModalFooter, ModalBody } from 'reactstrap';
import { withRouter } from 'react-router-dom';
import { gql } from 'apollo-boost';
import { Mutation, withApollo } from 'react-apollo';
import TankTypeText from '~/components/tankTypeText/tankTypeText';

export const archiveTankMutation = gql`
  mutation archiveTank($id: Int!) {
    archiveTank(id: $id) {
      id
    }
  }
`;

export class TankArchive extends Component {
  state = {
    isOpen: false,
    submitting: false,
    error: null
  };

  setError = error => {
    this.setState({ error });
  };

  setSubmitting = submitting => {
    this.setState({ submitting });
  };

  onToggle = () => {
    this.setState({
      isOpen: !this.state.isOpen
    });
  };

  renderNopeModalInner = () => {
    // You can't delete an tank if it has products
    const { currentLot } = this.props.tank;

    return (
      <Fragment>
        <ModalHeader toggle={this.onToggle}>Cannot archive</ModalHeader>
        <ModalBody>
          <p className="mb3">
            You can't archive this tank as it currently in use by a lot. You'll need to finish lot{' '}
            <em>{currentLot.reference}</em> before you can archive.
          </p>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={this.onToggle}>
            Ok
          </Button>{' '}
        </ModalFooter>
      </Fragment>
    );
  };

  renderConfirmationModalInner = () => {
    const { client, tank, history } = this.props;
    const { name, type } = tank;
    const { submitting, error } = this.state;

    return (
      <Mutation mutation={archiveTankMutation}>
        {archiveTank => (
          <Fragment>
            <ModalHeader toggle={this.onToggle}>Are you sure?</ModalHeader>
            <ModalBody>
              {error && <Alert color="danger">{error}</Alert>}
              Are you sure you want to archive the <TankTypeText type={type} /> <em>{name}</em>?
            </ModalBody>
            <ModalFooter>
              <Button color="secondary" onClick={this.onToggle}>
                Cancel
              </Button>{' '}
              <Button
                didabled={submitting}
                color="primary"
                onClick={async () => {
                  try {
                    this.setSubmitting(true);
                    await archiveTank({
                      variables: {
                        id: tank.id
                      }
                    });
                    // Clear cache
                    client.resetStore();
                    history.push(`/tanks?archived=${name}`);
                  } catch (err) {
                    this.setSubmitting(false);
                    this.setError('An unknown error occured');
                  }
                }}
              >
                Archive
              </Button>
            </ModalFooter>
          </Fragment>
        )}
      </Mutation>
    );
  };

  render() {
    const { className, tank } = this.props;

    if (!tank) {
      // In some cases where tank comes though asyncronously, there is a chance that the tank
      // does not exist yet. If that is the case, don't render anything
      return null;
    }

    return (
      <Fragment>
        <Button className={className} color="danger" outline onClick={this.onToggle}>
          Archive
        </Button>
        <Modal isOpen={this.state.isOpen} toggle={this.onToggle}>
          {tank.currentLot ? this.renderNopeModalInner() : this.renderConfirmationModalInner()}
        </Modal>
      </Fragment>
    );
  }
}

export default withRouter(withApollo(TankArchive));



// WEBPACK FOOTER //
// ./src/containers/tankArchive/tankArchive.jsx